<template>
  <div class="detail-tab-content">
    <div class="title">{{title}}</div>
    <div class="content">
      <wt-form-table :key="4" :form.sync="form">
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="detail" slot-scope="data">积分抵扣物业费</template>
        </wt-form-table-list>
      </wt-form-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralUserWyPoint',
  isAutoComponent: true,
  props: ['id', 'title'],
  data() {
    return {
      form: {
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/exchange/integralExchangeDetail/userIntegralExchangeList', params: { userId: 0 }}
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '积分明细', key: 'detail', type: 'custom' },
          { name: '积分数', key: 'integral', type: 'text' },
          { name: '对应金额', key: 'money', type: 'text' },
          { name: '项目信息', key: 'projectInfo', type: 'text' },
          { name: '房产信息', key: 'roomInfo', type: 'text' },
          { name: '低费物业', key: 'org1Info', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true, searchButtonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.userId = this.id
  }
}
</script>

<style>
</style>
